import React from "react";
import { Col, Row, Button } from "reactstrap";
import Table from "../../../components/Table/Table";
import AttendanceFilter from "./AttendanceFilter";
import { notificationAction } from "../../../redux/reducers/notification_reducer";
import * as ActionTypes from "../../../redux/actions/types";
import moment from "moment";
import { Link } from "react-router-dom";
import { MdOutlinePostAdd } from "react-icons/md";
import LoadingMask from "../../../components/Loader/LoadingMask";
import ImageModel from "../../../components/image/ImageModel";

import { connect } from "react-redux";
import { getAllAttendanceList } from "./apiCalls";
let dateOne = moment().startOf("day").toDate();
let startDate = moment(dateOne).format("YYYY-MM-DD HH:mm");
let dateTwo = moment()
  .startOf("day")
  .add(23, "hour")
  .add(59, "minute")
  .toDate();
let endDate = moment(dateTwo).format("YYYY-MM-DD HH:mm");
let initialRange = startDate + " / " + endDate;
class StaffAttendance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pictureModal: false,
      imageUrl: "",
      person_type:"Z0FBQUFBQmlNeXNpdkVRQXBsSGl2a1h0LWEyRkFITV94ZjR3NkIyaXlUUmh2OUdiU0FkSjJBNmhlOTROU2I3UW9aOVRINUhFWjlnd1gyREk1V0ZUZ05sZnZfTEQ4dk1GLVE9PQ==",
      paginationData: [],
      toggle: false,
      selectedDateRange: initialRange,
      detectionList: [],
      selectedDetectionFilters: {
        person_number: "",
        person_name: "",
        department: null,
        attendance_type:null
        // selectedDateRange: initialRange
      },
      selectedValues: {
        selected_department: { label: "All", value: null },
        selected_attendance_type: { label: "All", value: null },
      },
      download: true,
    };
  }

  componentDidMount=async ()=> {
    const {selectedValues, selectedDetectionFilters} = this.state
    if(this.props.location.state != null){
    const {present } = this.props.location.state;
    this.setState(
      {
        selectedValues: {
          ...selectedValues,
          selected_attendance_type: present ? present : { label: "All", value: -1 },
        },
        selectedDetectionFilters: {
          ...selectedDetectionFilters,
          attendance_type: present ?.value,
        },
      },
      () => this.handleFilterDataTableList()
    )}
    else{
      this.handleFilterDataTableList();
    }
    await this.props.RecordPerPage(10)
    await this.props.PageNo(1);
     
   }

  componentDidUpdate(prevProps) {
    if (
      prevProps.sortname !== this.props.sortname ||
      prevProps.sortby !== this.props.sortby
    ) {
      this.handleFilterDataTableList();
    }
    if (prevProps.pageno !== this.props.pageno) {
      this.handleFilterDataTableList();
    }
    if (prevProps.recordperpage !== this.props.recordperpage) {
      this.props.PageNo(1);
      this.handleFilterDataTableList();
    }
  }

  handleDetectionClear = (e) => {
    let startDate = moment().startOf("date").format("YYYY-MM-DD HH:mm");
    let endDate = moment()
      .startOf("date")
      .hours(23)
      .minutes(59, "hour")
      .seconds(59, "min");
    let Range = startDate + " / " + endDate.format("YYYY-MM-DD HH:mm");

    this.setState(
      {
        selectedDetectionFilters: {
          person_number: "",
          person_name: "",
          department: null,
          attendance_type:null
        },
        selectedDateRange: Range,
        selectedValues: {
          selected_department: { label: "All", value: null },
          selected_attendance_type:{ label: "All", value: null }
        },
      },
      () => this.handleFilterDataTableList()
    );
    this.props.PageNo(1);
    this.props.RecordPerPage(10);
  };

  handleApplyFilter = () => {
    // this.props.Loading(true);
    this.props.PageNo(1);
    this.handleFilterDataTableList();
  };

  handleFilterFieldChange = (e) => {
    const { name, value } = e.target;
    const { selectedDetectionFilters } = this.state;

    if (name === "person_name" || name === "person_number") {
      this.setState({
        selectedDetectionFilters: {
          ...selectedDetectionFilters,
          [name]: value,
        },
      });
    }
  };

  handelDropDownChange = (selectedOption, obj) => {
    const { selectedValues, selectedDetectionFilters } = this.state;
    const { name } = obj;
    if (!selectedOption) {
      let defaultOption = { value: "", label: "All" };
      if (obj.name === "department" || obj.name === "attendance_type" ) {
        this.setState({
          selectedValues: {
            ...selectedValues,
            [`selected_${obj.name}`]: defaultOption,
          },
          selectedDetectionFilters: {
            ...selectedDetectionFilters,
            [name]: null,
          },
        });
      }
      return;
    }
    if(name == "attendance_type"){
      this.setState({
        selectedValues: {
          ...selectedValues,
         selected_attendance_type: selectedOption,
        },
        selectedDetectionFilters: {
        ...selectedDetectionFilters,
        [name]: selectedOption.id,
      },
      });
    }
      if(name == "department"){
    this.setState({
      selectedValues: {
        ...selectedValues,
        selected_department: selectedOption,
      },
      selectedDetectionFilters: {
        ...selectedDetectionFilters,
        [name]: selectedOption.id,
      },
    });
  }
  };

  handleExportCsv = () => {
    this.setState({ appLoadingState: true });
    const { person_type, selectedDateRange } = this.state;
    const { person_number, person_name, department, attendance_type } =
      this.state.selectedDetectionFilters;
    getAllAttendanceList(
      this.props.recordperpage ? this.props.recordperpage : null,
      this.props.pageno ? this.props.pageno : null,
      this.props.sortname ? this.props.sortname : null,
      this.props.sortby ? this.props.sortby : null,
      person_name ? person_name.replace(/^\s+|\s+$/g, "") : null,
      person_number ? person_number.replace(/^\s+|\s+$/g, "") : null,
      department ? department : null,
      attendance_type ? attendance_type : null,
      selectedDateRange ? selectedDateRange : null,
      person_type ? person_type : null,
      this.state.download ? 1 : null
    )
      .then((response) => {
        if (response.code == 200) {
          if (response.data.file_url != null) {
            window.open(response.data.file_url, "_blank");
          }
        }
          this.setState({ appLoadingState: false })
      })
      .catch((error) => console.log("Erorr in getting staffs ", error));
  };
  handleFilterDataTableList = async () => {
    const { person_type, selectedDateRange } = this.state;
    this.setState({ appLoadingState: true });

    const { person_number, person_name, department, attendance_type } =
      this.state.selectedDetectionFilters;
    await getAllAttendanceList(
      this.props.recordperpage ? this.props.recordperpage : null,
      this.props.pageno ? this.props.pageno : null,
      this.props.sortname ? this.props.sortname : null,
      this.props.sortby ? this.props.sortby : null,

      person_name ? person_name.replace(/^\s+|\s+$/g, "") : null,
      person_number ? person_number.replace(/^\s+|\s+$/g, "") : null,
      department ? department : null,
      attendance_type ? attendance_type : null,
      selectedDateRange ? selectedDateRange : null,
      person_type ? person_type : null
    )
      .then((response) => {
        if (response.code == 200) {
          this.setState({
            detectionList: response.data.dataset,
            paginationData: response.data.pagination,
            appLoadingState: false,
          });
        } else if (response.code != 200) {
          this.setState({ appLoadingState: false });
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
        } else {
        }
      })
      .catch((error, response) => {
        const info = {
          message: error.message,
          status: "error",
        };

        this.props.notificationAction(info);
      });
  };
  handleDateApply = (event, picker) => {
    let startDate = picker.startDate.format("YYYY-MM-DD HH:mm");
    let endDate = picker.endDate.format("YYYY-MM-DD HH:mm");
    let Range = startDate + " / " + endDate;
    this.setState({
      selectedDateRange: Range,
    });
  };
  handelShowPictureModal = (item) => {
    this.setState({
      pictureModal: item && !this.state.pictureModal,
      imageUrl: item,
    });
  };

  render() {
    let template;
    const boolRfid = process.env.REACT_APP_RFID;
    template = (
      <div>
        <Row>
          {this.state.appLoadingState ? <LoadingMask /> : null}
          <Col md={6} lg={6}></Col>
          <Col md={6} lg={6} >
          <Link to="/staff-reports/attendance-report/mark-attendance">
              <Button color="primary" className="pull-right mr-3 mb-3">
                <MdOutlinePostAdd size={20} /> &nbsp; Mark Attendance
              </Button>
            </Link>
            </Col>

        </Row>
        <AttendanceFilter
          SelectedValues={this.state.selectedValues}
          onDDChange={this.handelDropDownChange}
          selectedDetectionFilters={this.state.selectedDetectionFilters}
          onFilterReset={this.handleDetectionClear}
          onExportCsv={this.handleExportCsv}
          onApply={this.handleDateApply}
          selectedDateRange={this.state.selectedDateRange}
          onFilterFieldChange={this.handleFilterFieldChange}
          onFilterDetection={this.handleApplyFilter}
        />
        <ImageModel
          show={this.state.pictureModal}
          imageUrl={this.state.imageUrl}
          onModalClose={this.handelShowPictureModal}
        />

        <Row>
          <Col className="pr-grid-col" xs={12} lg={12}>
            {this.state.detectionList && this.state.detectionList.length > 0 ? (
              <Table
                data={this.state.detectionList}
                isImageEnabled={true}
                isImageCircle={true}
                isImageSquare={[true, false]}
                isCheckOption={false}
                onShowPicture={this.handelShowPictureModal}
                listItemToDisplay={[
                  { name: "Staff", valueField: "person_name" },
                  boolRfid && boolRfid === "true" ? { name: "RFID", valueField: "rfid" } : "",
                  { name: "Employee #", valueField: "reg_number" },
                  { name: "Department", valueField: "department" },
                  { name: "Attendance Status", valueField: "attendance_type" },
                  { name: "Grade ", valueField: "grade" },
                  { name: "Date ", valueField: "attendance_date" },
                  { name: "IN-Time", valueField: "in_time" },
                  { name: "OUT-Time", valueField: "out_time" },
                ]}
                paginationData={this.state.paginationData}
                buttonsToDisplay={[]}
              />
            ) : (
              <div className="text-center">
                There is no data available to show
              </div>
            )}
          </Col>
        </Row>
      </div>
    );

    return(
      <div className="">{template} </div>);
  }
}

const actions = (dispatch) => ({
  notificationAction: (message, status) =>
    dispatch(notificationAction(message, status)),
  RecordPerPage: (recordperpage) =>
    dispatch({ type: ActionTypes.RECORDS_PER_PAGE, recordperpage }),
  PageNo: (pageno) => dispatch({ type: ActionTypes.PAGE_NO, pageno }),
  SortName: (sortName) => dispatch({ type: ActionTypes.SORT_NAME, sortName }),
});
const mapStateToProps = (state) => ({
  pageno: state.tab.pageno,
  recordperpage: state.tab.recordperpage,
  sortby: state.tab.sortBy,
  sortname: state.tab.sortName,
});

export default connect(mapStateToProps, actions)(StaffAttendance);
